import React from 'react'
import isEmpty from 'lodash/isEmpty'
import type { GlobalSearchResult } from '@ztechapps/common.contract'
import { ListGroupItem } from 'react-bootstrap'
import { truncate } from '@ztechapps/common.utils'

export type GlobalSearchResultItemProps = {
  result: GlobalSearchResult
  onClick: (result: GlobalSearchResult) => void
  isLast?: boolean
}

export const GlobalSearchResultItem = ({ result, onClick, isLast = false }: GlobalSearchResultItemProps) => {
  return (
    <ListGroupItem action onClick={() => onClick(result)} className={isLast ? 'border-bottom-0' : undefined}>
      <div className="d-flex align-items-start">
        <div className="flex-grow-1">
          <div className="fw-bold">
            {!isEmpty(result.code) && <span className="me-2">{result.code}</span>}
            {!isEmpty(result.name) && <span>{result.name}</span>}
          </div>
          {!isEmpty(result.summary) && <div className="text-muted small">{truncate(result.summary, 100)}</div>}
        </div>
      </div>
    </ListGroupItem>
  )
}
